<div class="panel">
  <span *ngIf="title" class="label">{{ title }}</span>
  <button type="button" class="value" [disabled]="disabled" (click)="open()">
    {{ display }}° F
  </button>
</div>

<ion-modal
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  [handle]="false"
  [keepContentsMounted]="true"
>
  <ng-template>
    <div class="picker">
      <ion-picker>
        <!-- Only the number scrolls; "° F" is a static suffix Ionic aligns to the selection line. -->
        <ion-picker-column
          [value]="selected"
          (ionChange)="onColumnChange($event)"
        >
          <!-- Visual is number-only; screen readers get the full "N° F" via aria-label. -->
          <ion-picker-column-option *ngFor="let t of options" [value]="t" [attr.aria-label]="label(t)">
            {{ t }}
          </ion-picker-column-option>
          <div slot="suffix" class="unit">° F</div>
        </ion-picker-column>
      </ion-picker>

      <div class="button" (click)="onApply()">Set</div>
    </div>
  </ng-template>
</ion-modal>
